import  {  Context, createContext } from 'react';
import { Messenger } from "./components/Messenger";

export const AppContext: Context<ApplicationContext> = createContext<ApplicationContext>(null);

export class ApplicationContext {


    constructor(private location:{search, pathname, hash}){}

    messenger: Messenger = new Messenger(this.location);

    /*
    connection: signalR.HubConnection = new signalR.HubConnectionBuilder()
        //.withUrl("https://localhost:44463/messenger")
        .withUrl("https://mrmessengerwebclient.azurewebsites.net/messenger")
        .withAutomaticReconnect()
        //.configureLogging(signalR.LogLevel.Trace)
        .build();

    */



}